import React, { useState, useRef }  from "react";
import { Button, ButtonGroup, Card, Form, Table } from "react-bootstrap";
import { States, AuthState } from "../../../interfaces/states";
import { SharedProps } from "../../home/Home";
import { useSelector, useDispatch } from "react-redux";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { AuthApis } from "../../../apis/authApis";
import { HttpBasicAuth, AuthResponseModel } from "../../../interfaces/models";
import { AxiosResponse, AxiosError } from "axios";
import { Link, NavLink, useHistory } from "react-router-dom";
import { AppRoutes, HomeRoutes } from "../../../enums/routes";
import configs from "../../../configs";
import { Dispatch } from "redux";
import { toggleNotification } from "../../../actions";
import { NotificationProps } from '@sebgroup/react-components/dist/notification/Notification';
import { TextArea } from '@sebgroup/react-components/dist/TextArea';
import { version } from "../../../actions/pageSizeAction";
import Table2 from 'react-bootstrap/Table';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import sign from './signn.png';
import Modal from 'react-awesome-modal';


export interface SettingsProps extends SharedProps { }

interface SigninProps extends SharedProps {
    setAccountMode: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
    auth: HttpBasicAuth;
    errors: HttpBasicAuth;
    loading: boolean;
}



const PublicPO: React.FunctionComponent<SigninProps> = React.memo(
    (props: SigninProps): React.ReactElement<void> => {


        const [screen, setScreen] = React.useState('1');

        const exportAsPdf = async (elementId: string, fileName: string) => {
            const input = document.getElementById(elementId);
            if (!input) {
                console.error(`No element found with id: ${elementId}`);
                return;
            }
    
            const pdf = new jsPDF('p', 'pt', 'a4'); // A4 size
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
    
            const canvas = await html2canvas(input, { scale: 2 }); // Scale to increase resolution
            const imgData = canvas.toDataURL('image/png');
    
            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
            let heightLeft = imgHeight;
            let position = 0;
    
            // Add the first page
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
    
            // Add additional pages if necessary
            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }
    
            pdf.save(`${fileName}.pdf`);
        };
    
    
        const componentRef = useRef<HTMLDivElement>(null);
    
        const handleExportClick = () => {
            if (componentRef.current) {
                exportAsPdf(componentRef.current.id, 'Purchase Order Document');
            }
        }

        

        return (
            <>
                {/* PUBLIC NAVBAR */}
                <div>
                    <nav className="  navbar navbar-expand-lg shadow fixed-top2" style={{ backgroundColor: '#FEFEFE' , height:"60px"}}>
                        <div className="container-fluid">
                            <div className="navbar-container">
                                <img src={`${process.env.PUBLIC_URL}/assets/img/logobig.png`} alt="mail-icon" height="100%" width="150px"/>
                            </div>
                        </div>
                    </nav>
                </div>
                {/* BODY */}
                <div style={{ backgroundColor: '#FAFAFB', padding: '50px' }}>
                    

                    {/* PREVIEW RFQ */}
                    <div className={screen == "1" ? 'd-block' : 'd-none'}>
                        <div className="d-flex justify-content-center">
                            <div>
                                <h3 className="text-center" style={{color:"#23262F"}}>Purchase Order Confirmation</h3>
                                <p className="pt-1" style={{color:"#23262F", fontSize:"14px"}}>Enter the information below to report a breakdown on this asset</p>
                            </div>

                        </div>
                        <div className="d-flex justify-content-center pt-3">
                            <div className=" p-3 mb-5 shadow bg-white my-3 mx-5" style={{ width: "650px", margin: "auto", borderRadius: "16px" }}>
                            <div className='d-flex justify-content-between' style={{ padding: '10px 20px' }}>
                        <span style={{ fontSize: '22px', fontWeight: '600' }}>Preview </span>
                       
                    </div>

                    <hr className="mx-3"/>
                   
                    <div id="componentToExport" className=" p-3" style={{ background: "white" }} ref={componentRef}>
                        <div className="mt-3 p-2 shadow" style={{ border: "1px solid #B1B5C3", borderRadius: "15px" }}>
                            <div style={{ background: "#F2F5F9", padding: "14px 16px 14px 16px", borderRadius: "12px" }}>
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <h4 style={{ fontSize: "20px", fontWeight: 600, color: "#121722" }}>AMS</h4>
                                        <h5 className="mt-2" style={{ fontSize: "10px", color: "#60737D", fontWeight: "400", width: "170px" }}>Unit 9-06, Level 9, Menara K1, No. 1, Lorong 3/137C, Off Jalan Klang Lama, 58200 Kuala Lumpur</h5>
                                        <h5 className="mt-2" style={{ fontSize: "10px", color: "#60737D", fontWeight: "400", }}>+60377847594</h5>
                                    </div>
                                    <div>

                                        <h4 style={{ fontSize: "20px", fontWeight: 600, color: "#121722" }}>Purchase Order</h4>
                                        <h5 className="mt-2" style={{ fontSize: "10px", color: "#60737D", fontWeight: "400", }}><span style={{ fontSize: "12px", color: "#121722", fontWeight: "700" }}>Date:</span> Nov 12, 2024</h5>
                                        <h5 className="mt-2" style={{ fontSize: "10px", color: "#60737D", fontWeight: "400", }}><span style={{ fontSize: "12px", color: "#121722", fontWeight: "700" }}>P.O Number:</span> 3254323</h5>
                                        <h5 className="mt-2" style={{ fontSize: "10px", color: "#60737D", fontWeight: "400", }}><span style={{ fontSize: "12px", color: "#121722", fontWeight: "700" }}>Vendor Id:</span> 8765322</h5>
                                    </div>
                                </div>

                            </div>

                            <div className="row mt-4 px-2">
                                <div className="col-md-6">
                                    <h4 style={{ fontSize: "20px", fontWeight: 500, color: "#121722" }}>Vendor</h4>
                                    <h4 className="mt-2" style={{ fontSize: "14px", fontWeight: 600, color: "#121722" }}>Medequip Sdn. Bhd.</h4>
                                    <h5 className="mt-2" style={{ fontSize: "14px", color: "#60737D", fontWeight: "400", width: "170px" }}> Level 5, Menara Star,15 Jalan 16/11, Seksyen 16,46350 Petaling Jaya,Kuala Lumpur, Malaysia</h5>
                                </div>
                                <div className="col-md-6">
                                    <h4 style={{ fontSize: "20px", fontWeight: 500, color: "#121722" }}>Ship To</h4>
                                    <h4 className="mt-2" style={{ fontSize: "14px", fontWeight: 600, color: "#121722" }}>Global Ship Logistics Sdn. Bhd.</h4>
                                    <h5 className="mt-2" style={{ fontSize: "14px", color: "#60737D", fontWeight: "400", width: "170px" }}> Suite 8-03, Level 8, Wisma UOA II,21 Jalan Pinang,50450 Kuala Lumpur,Malaysia</h5>
                                </div>
                            </div>

                            <hr className="mt-4" />

                            <div>
                                <Card.Body className={"card-body"} style={{ overflow: 'auto', width: 'auto', paddingTop: "10px" }}>
                                    <Table2 className="table table-hover" >
                                        <thead >
                                            <tr>
                                                <th className="" style={{}} >Part Name</th>
                                                <th className="" >Quantity</th>
                                                <th className="" >Unit Price</th>

                                                <th className="" >Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td >Syringe</td>
                                                <td>12</td>
                                                <td> 400 RM    </td>
                                                <td>4800 RM </td>
                                            </tr>

                                            <tr>
                                                <td >Syringe</td>
                                                <td>12</td>
                                                <td> 400 RM    </td>
                                                <td>4800 RM </td>
                                            </tr>
                                            <tr>
                                                <td >Syringe</td>
                                                <td>12</td>
                                                <td> 400 RM    </td>
                                                <td>4800 RM </td>
                                            </tr>
                                            <tr>
                                                <td >Syringe</td>
                                                <td>12</td>
                                                <td> 400 RM    </td>
                                                <td>4800 RM </td>
                                            </tr>

                                        </tbody>
                                    </Table2>
                                </Card.Body>
                            </div>

                            <div className="d-flex justify-content-between px-2">
                                <div>
                                    <div style={{ marginTop: "10px" }}>
                                        <h3 style={{ fontSize: "10px", color: "#121722", fontWeight: "600" }}>Terms and Conditions</h3>
                                        <h4 className="mt-2" style={{ fontSize: "10px", fontWeight: "400", color: "#60737D" }}>Payment Upon Delivery</h4>
                                    </div>
                                    <div className="" style={{ marginTop: "60px" }}>
                                        <h3 style={{ fontSize: "10px", color: "#121722", fontWeight: "600" }}>Additional Notes</h3>
                                        <h4 className="mt-2" style={{ fontSize: "10px", fontWeight: "400", color: "#60737D" }}>---</h4>
                                    </div>
                                </div>
                                <div>
                                    <div className="d-flex justify-content-end" style={{ marginBottom: "20px" }}>
                                        <div className="px-2 pt-2" style={{ borderRadius: "8px", boxShadow: "0px 0px 4px #00000040", marginTop: "10px", width: "20rem" }}>
                                            <div className="d-flex justify-content-between py-2 px-2">
                                                <div><h5 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>Subtotal</h5></div>
                                                <div><h4 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>4,800.00 RM</h4></div>
                                            </div>
                                            <hr />
                                            <div className="d-flex justify-content-between py-2 px-2">
                                                <div><h5 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>Shipping Charges</h5></div>
                                                <div><h4 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>100.00 RM</h4></div>
                                            </div>
                                            <hr />
                                            <div className="d-flex justify-content-between py-2 px-2">
                                                <div><h5 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>Discount</h5></div>
                                                <div><h4 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>20.00 RM</h4></div>
                                            </div>
                                            <hr />
                                            <div className="d-flex justify-content-between py-2 px-2">
                                                <div><h5 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>Tax</h5></div>
                                                <div><h4 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>470.00 RM</h4></div>
                                            </div>
                                            <hr />
                                            <div className="d-flex justify-content-between py-2 px-2">
                                                <div><h5 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>Total Amount</h5></div>
                                                <div><h4 style={{ color: "#353945", fontSize: "16px", fontWeight: "500" }}>5,350.00 RM</h4></div>
                                            </div>
                                            <hr />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <hr className="mt-2 " />

                            <div className="mt-3 mb-4 px-2">

                                <h3 style={{ fontWeight: "600", fontSize: '20px', color: '#121722' }}>Approved By:</h3>
                                <div>

                                    <div className="row" style={{ marginTop: "25px", }}>
                                        <div className="col-md-6"><img src={sign} style={{ width: "60px", marginLeft: "30px" }} /></div>
                                        <div className="col-md-6"><h3 className="" style={{ fontSize: "18px", color: "#353945" }}>12 Nov, 2024</h3></div>
                                    </div>
                                    <div style={{ height: "1px", background: "black", marginTop: "5px" }}></div>


                                    <div className="row" style={{ marginTop: "10px", }}>
                                        <div className="col-md-6"><h3 className="" style={{ fontSize: "14px", color: "#353945" }}>Authorized Signature</h3></div>
                                        <div className="col-md-6"><h3 className="" style={{ fontSize: "14px", color: "#353945" }}>Date</h3></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4 mb-3 px-3">
                        <button className="btn btn-sm py-2 px-3" 
                       onClick={handleExportClick}
                        style={{ backgroundColor: '#fff', color: "#3F83F8", border: '1px solid #3F83F8' }}>
                            Download
                        </button>

                        <button className="btn btn-sm ml-2 py-1"
                        // onClick={handleExportClick}
                         style={{ backgroundColor: '#3F83F8', color: "#fff" }} >
                            
                           <span className="">Confirm Purchase Order</span> 
                        </button>
                    </div>



                            </div>
                        </div>
                    </div>

                    <div className={screen == "3" ? 'd-block' : 'd-none'}>
                        <div className="d-flex justify-content-center" style={{ marginTop: "100px" }}>
                            <div className="px-5 py-3 mb-5 shadow bg-white my-3 mx-5" style={{ width: "550px", margin: "auto", borderRadius: "12px" }}>
                                <div className="d-flex justify-content-center pt-2">
                                    <img src={`${process.env.PUBLIC_URL}/assets/img/mail.png`} alt="mail-icon" />
                                </div>

                                <div className="text-center mt-4 mb-4">
                                    <h3 style={{ color: "#23262F", fontSize: "23px" }}>Quotation Sent Successfully</h3>
                                    <p className="pt-1" style={{ color: "#23262F", fontSize: "14px" }}> Your quotation has been sent successfully to the customer</p>
                                </div>
                                <div className="pb-2">
                                    <button className="btn btn-sm py-1" style={{ backgroundColor: '#3F83F8', color: "#fff", width: "100%" }}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>


        );
    }
);

export default PublicPO;